module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }